import { useState } from 'react';

import { useServerClient } from '../useServerClient';
import { useServerParams } from '../useServerParams';

export const currencyTypes = {
    myr: "MYR",
    sgd: "SGD",
    usd: "USD",
    cny: "CNY"
}

export const targetTypes = {
    wallet: "wallet",
    walletUser: "wallet_user"
}


export function useWallets({
    targetType: _targetType
}) {

    // const [rateType, setRateType] = useState(_currencyType);
    const [targetType, setTargetType] = useState(_targetType)

    const { makeCall, getError } = useServerClient();
    const { getListsUrl, getUrlWithDataTypes, _operatorDef: filterOperatorTypes } = useServerParams();

    const [isLoading, setIsLoading] = useState(false)

    const endpoint = "wallets";
    const endpoint2 = "wallet";

    const list = async (props) => {

        setIsLoading(true);

        try {

            let { targetType: overrideTargetType } = props

            let url = getListsUrl(`${endpoint}/${targetType}`, props)

            if (overrideTargetType) {
                url = getListsUrl(`${endpoint}/${overrideTargetType}`, props)
            }

            const response = await makeCall({
                url,
                method: "GET",
                payload: {}
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    const create = async ({ data, targetType: overrideTargetType }) => {

        setIsLoading(true)

        try {

            const url = endpoint2;

            let postData = {
                scope: {
                    target: targetType,
                    action: "",
                },
                payload: data
            }

            if (overrideTargetType) postData.scope.target = overrideTargetType

            const response = await makeCall({
                url,
                method: "POST",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    const update = async ({ id, data, targetType: overrideTargetType }) => {

        setIsLoading(true)

        try {

            const url = `${endpoint2}/${id}`

            let postData = {
                scope: {
                    target: targetType,
                    action: "",
                },
                payload: data
            }

            if (overrideTargetType) postData.scope.target = overrideTargetType

            const response = await makeCall({
                url,
                method: "PUT",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    const remove = async ({ ids }) => {

        setIsLoading(true);

        if (ids.length <= 0) {
            throw getError(false, `Please select at least (1) items`)
        }

        try {

            let url = `${endpoint}/delete`

            const postData = {
                scope: {
                    target: targetType
                },
                payload: {
                    ids
                }
            }

            const response = await makeCall({
                url,
                method: "POST",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    const get = async ({ id, targetType: overrideTargetType = '', dataTypesArray = [] }) => {

        setIsLoading(true);

        try {

            let url = getUrlWithDataTypes(`${endpoint2}/${targetType}/${id}`, dataTypesArray);

            if (overrideTargetType) {
                url = getUrlWithDataTypes(`${endpoint2}/${overrideTargetType}/${id}`, dataTypesArray);
            }

            const response = await makeCall({
                url,
                method: "GET",
                payload: {}
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    return {
        isLoading,
        filterOperatorTypes,
        list,
        get,
        create,
        update,
        remove
    }
}